export default __webpack_public_path__ + "static/media/SENAIT_NL_INTRO.017c4280.mp3";